// extracted by mini-css-extract-plugin
export var alternate = "_1r-j";
export var black = "_1r-6";
export var blue = "_1r-f";
export var blueLight = "_1r-e";
export var brand = "_1r-8";
export var darkMode = "_1r-b";
export var error = "_1r-a";
export var gray = "_1r-5";
export var grayBlue = "_1r-d";
export var iconWrapper = "_1r-3";
export var inactive = "_1r-7";
export var indigo = "_1r-g";
export var orange = "_1r-i";
export var pink = "_1r-h";
export var primary = "_1r-0";
export var purple = "_1r-9";
export var success = "_1r-4";
export var warning = "_1r-c";
export var white = "_1r-1";
export var whiteSuccess = "_1r-2";